var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompliancePptxFileLargeExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 141,
  height: 148,
  viewBox: "0 0 141 148",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#nlnnthsnsa)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 1h96.213L139 37.793V141a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4z",
  fill: "#F0EFEF"
})), /*#__PURE__*/React.createElement("mask", {
  id: "d2ce5s0ikb",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 71,
  y: 50,
  width: 22,
  height: 21
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.847 50h20.174v20.514H71.847V50z",
  fill: "#ABABAB"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#d2ce5s0ikb)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.41 70.514h20.175C90.68 59.554 82.127 50.844 71.41 50v20.514z",
  fill: "#ABABAB"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.847 74.076C88.847 85.632 79.48 95 67.923 95 56.368 95 47 85.632 47 74.076c0-11.555 9.368-20.923 20.923-20.923v20.923h20.924z",
  fill: "#ABABAB"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.213 1 139 37.793h-32.787a4 4 0 0 1-4-4V1z",
  fill: "#ABABAB"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "nlnnthsnsa",
  x: 0,
  y: 0,
  width: 141,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_390_567"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_390_567",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompliancePptxFileLargeExpired);
export default ForwardRef;